import { DataService } from "@/services/data";
import { MetadataService } from "@/services/metadata";
import { VaultCredentialDetailType } from "@/types/tools/vault_credential";
import { Outlet, RouteObject } from "react-router-dom";

const VaultRoute: RouteObject = {
    path: "coffre",
    element: <Outlet />,
    children: [
        {
            index: true,
            async lazy() {
                const { VaultCredentialList } = await import("@/pages/tools/vault/list");
                return { Component: VaultCredentialList };
            },
            loader: async () => {
                const metadata = await MetadataService.get("/crm/objects/vault-credentials/");
                return { metadata };
            },
        },
        {
            id: "vault-credential-detail",
            path: ":id",
            async lazy() {
                const { VaultCredentialView } = await import("@/pages/tools/vault/view");
                return { Component: VaultCredentialView };
            },
            loader: async ({ params }) => {
                const credential = (await DataService.client
                    .url(`/crm/objects/vault-credentials/${params.id}/`)
                    .get()
                    .json()) as VaultCredentialDetailType;
                const metadata = await MetadataService.get("/crm/objects/vault-credentials/");
                return { credential, metadata };
            },
            children: [
                {
                    path: ":tabPath",
                    async lazy() {
                        const { GenericDetailDynamicTabPage } = await import(
                            "@/components/layout/generic-detail-dynamic-tab-page"
                        );
                        return {
                            Component: () => <GenericDetailDynamicTabPage objectType="vault-credentials" idParam="id" />,
                        };
                    },
                },
            ],
        },
    ],
};

export default VaultRoute;
